import { Component, OnInit } from '@angular/core';
import { BillingControlService } from '../service/billing-control.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { BcClientListComponent } from '../../bc-client-list/bc-client-list.component';

@Component({
  selector: 'app-bc-effective-status',
  templateUrl: './bc-effective-status.component.html',
  styleUrls: ['./bc-effective-status.component.scss']
})
export class BcEffectiveStatusComponent implements OnInit {

  private BcEffectiveStatusData = [];
  private BcEffectiveStatusTotal = 0;

  //Chart Configuration and Data
  hasLegend = 'true'
  chartType = 'pie'
  private chartData = [
    {
      data: []
    }
  ];
  private chartLabels = [];
  private showChart = false;
  private isLoaded = false;

  constructor(private billingControlService: BillingControlService, private dialogService: DialogService) {
  }

  ngOnInit() {
  }

  onOpenAccordion() {
    if (this.isLoaded == false) {
      this.getBCEffectiveStatus();
    }
  }

  getBCEffectiveStatus() {
    this.billingControlService.getBCEffectiveStatus().subscribe(result => {
      if (result.Success) {
        this.BcEffectiveStatusData = result.Result || [];
        this.BcEffectiveStatusTotal = result.Total;
        this.isLoaded = true;
        this.defineChartByEffectiveStatusData();
      } else {
        console.log("Erro ao carregar dados!");
      }
    }, error => {
      console.log(error);
    });
  }

  defineChartByEffectiveStatusData() {
    if (this.BcEffectiveStatusData.length > 1) {
      this.BcEffectiveStatusData.forEach((row, index) => {
        this.addChartData(row.Nome, row.Percentual);
        if (index == this.BcEffectiveStatusData.length - 1) {
          this.showChart = true;
        }
      });
    }
  }

  addChartData(label, data) {
    const tempChartData = this.chartData[0].data;
    tempChartData.push(data);
    this.chartData[0].data = tempChartData;
    this.chartLabels.push(label);
  }

  openModal(tipo, chave, dias) {
    const objToList = {
      Tipo: tipo,
      Chave: chave == '' ? undefined : chave,
      Dias: dias,
      Diretoria: this.billingControlService.selectedDirectorship
    };
    this.dialogService.addDialog(BcClientListComponent, { obj: objToList }, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
  }
}



// WEBPACK FOOTER //
// ./src/app/billing-control/billing-control/bc-effective-status/bc-effective-status.component.ts